import { render, staticRenderFns } from "./CdrByMonth.vue?vue&type=template&id=6b63a5e0&scoped=true"
import script from "./CdrByMonth.vue?vue&type=script&lang=js"
export * from "./CdrByMonth.vue?vue&type=script&lang=js"
import style0 from "./CdrByMonth.vue?vue&type=style&index=0&id=6b63a5e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b63a5e0",
  null
  
)

export default component.exports